import { IIconProps } from './constants';

interface ILikeIconProps extends IIconProps {
  isLiked: boolean;
}

export const LikeIcon = ({
  size,
  height = 24,
  width = 24,
  strokeWidth = 2,
  title = '',
  ariaLabel = '',
  ariaHidden = false,
  isLiked,
}: ILikeIconProps) => (
  <svg
    width={size ?? width}
    height={size ?? height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={ariaLabel}
    aria-hidden={ariaHidden}
  >
    {title && <title>{title}</title>}
    {isLiked ? (
      <>
        <path
          d="M2.83398 22.0189C3.36571 22.5421 4.08392 22.8333 4.8291 22.8333L5.35352 22.8333V10.9329H4.8291C4.08393 10.9329 3.36571 11.2241 2.83398 11.7474C2.30171 12.2712 2 12.9859 2 13.7337V20.0335C2.00008 20.7812 2.30184 21.4951 2.83398 22.0189Z"
          fill="currentcolor"
        />
        <path
          d="M19.1504 9.13312H14.9746V6.53351C14.9746 5.54703 14.5758 4.60404 13.8721 3.91144C13.1688 3.21937 12.2182 2.83331 11.2305 2.83331C10.8867 2.83336 10.5707 3.00941 10.3887 3.29327L10.3193 3.42218L7.12231 10.5V22.8331L17.8887 22.8323C18.5623 22.8371 19.218 22.6049 19.7354 22.1722C20.2561 21.7366 20.6025 21.1272 20.7061 20.4554L20.7051 20.4544L21.9678 12.3558C22.03 11.9523 22.0022 11.5403 21.8867 11.1487C21.7712 10.7572 21.5709 10.3959 21.3008 10.0901C21.0307 9.78448 20.6971 9.54103 20.3242 9.37628C19.9547 9.21307 19.5542 9.13021 19.1504 9.13312Z"
          fill="currentcolor"
        />
      </>
    ) : (
      <path
        d="M7.57256 11.9333L11.2306 3.83331C11.9582 3.83331 12.6561 4.11777 13.1706 4.62412C13.6851 5.13046 13.9741 5.81722 13.9741 6.5333V10.1333H19.1503C19.4154 10.1303 19.678 10.1841 19.9199 10.291C20.1618 10.3978 20.3772 10.5551 20.5512 10.752C20.7251 10.9489 20.8535 11.1807 20.9275 11.4313C21.0014 11.6819 21.0191 11.9453 20.9793 12.2033L19.7173 20.3032C19.6511 20.7324 19.4296 21.1236 19.0935 21.4048C18.7574 21.686 18.3293 21.8381 17.8882 21.8332H7.57256M7.57256 11.9333V21.8332M7.57256 11.9333H4.82902C4.34394 11.9333 3.87872 12.1229 3.53571 12.4605C3.1927 12.798 3 13.2559 3 13.7332V20.0332C3 20.5106 3.1927 20.9684 3.53571 21.306C3.87872 21.6436 4.34394 21.8332 4.82902 21.8332H7.57256"
        stroke="currentcolor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);
